export default __webpack_public_path__ + "static/media/users.ca72981b.svg";